import { UserSubscriptionType } from '../../services/subscriptions/subscriptions.types';

/**
 * Values from this enum are used for segment tracking
 * please do not edit it without specific reason
 */
export enum UserPlanType {
  Clinic = 'clinic',
  Professional = 'professional',
  Free = 'free',
  Premium = 'premium',
}

export const subscriptionTypeToPlanTypeMap: Record<
  UserSubscriptionType,
  UserPlanType
> = {
  [UserSubscriptionType.Premium]: UserPlanType.Premium,
  [UserSubscriptionType.Pro]: UserPlanType.Professional,
  [UserSubscriptionType.Trial]: UserPlanType.Professional,
  [UserSubscriptionType.Clinic]: UserPlanType.Clinic,
  [UserSubscriptionType.Free]: UserPlanType.Free,
} as const;

export type UseUserSubscriptionReturnType = {
  plan: UserSubscriptionType | undefined;
  isPaidUser: boolean;
  userPlanType: UserPlanType | undefined;
};
